<template>
  <a-layout class='index animated fadeIn'>
    <div class="s_bf p-t-10">
      <div class="mb25 s_flex_bian_c">
        <span class='mr15'>
          <a-button type="primary" @click="openAdd(0)">
            <PlusOutlined />
            新建包邮卡
          </a-button>
        </span>
      </div>
      <a-form ref='forms' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search"
        :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="包邮卡编码" name='id'>
          <a-input v-model:value="search.id" style="width:200px" placeholder="请输入包邮卡编码进行搜索" />
        </a-form-item>
        <a-form-item label="状态" name='status'>
          <a-select v-model:value="search.status" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="0">关闭</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="创建时间" name=''>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change='onChange'/>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
        <!-- <a-form-item>
          <a-button type="primary" ghost>导出</a-button>
        </a-form-item> -->
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
        <template v-slot:action="{ record }">
          <a-dropdown>
            <a class="ant-dropdown-link"> 操作
              <DownOutlined />
            </a>
            <template v-slot:overlay>
              <a-menu>
                <a-menu-item>
                  <a @click="openAdd(record)"  href="javascript:;" >编辑</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click='parcelState(record)' href="javascript:;" >{{record.status?'禁用':'启用'}}</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
        :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
        @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </div>
  </a-layout>
  <a-modal  :keyboard="false" :title="form.id ? '编辑包邮卡':'添加包邮卡'" :width='900' centered :footer="null" v-model:visible="visible" destroyOnClose @cancel='handleCancel'>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item ref="number" label="每月可领取" name="number">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-input-number class="width100" v-model:value="form.number" :min='1' placeholder='请输入数量' />
          </a-col>
          <a-col :span="12">
            <p>包邮卡（全国包邮）</p>
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item ref="day" label="包邮卡有效时长" name="day">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-input-number class="width100" v-model:value="form.day" :min="1" :max="90" placeholder='请输入有效时长' />
          </a-col>
          <a-col :span="12">
            <p>最多90天。自领取之日算起N天有效期</p>
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 4, offset: 4 }">
        <a-button type="primary" @click="onSubmit">
          保存
        </a-button>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
  import { PlusOutlined,DownOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { getParcelList,setParcelAdd,setParcelEdit,setParcelState,getParcelMore } from "@/api/assets";
  import { iscode } from "@/utils/app";

  // 初始化默认筛选项数值
  let defSearch = {
    id: '',
    page: 1,
    limit: 10,
    start_time: '',
    end_time: '',
    status: ''
  };
  let defForm = {
    number: '',
    day: ''
  }
  export default {
    cardList: 'cardList',
    components: { PlusOutlined,DownOutlined },
    setup(props, ctx) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      const form = ref({ ...defForm });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        listLoading: false,
        time: [],
        times: [],
        total: 1,
        labelCol: { span: 4 },
        wrapperCol: { span: 16 },
        visible: false,
        rules: {
          number: [
            { required: true, message: '请输入每月可领取数量', },
          ],
          day: [
            { required: true, message: '请输入包邮卡有效时长', },
          ],
        }
      });
      let columns = [
        {
          title: "包邮卡编码",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          key: "create_time",
        },
        {
          title: "每月可领",
          dataIndex: "number",
          customRender:({record})=>{
            return  record.number+'张'
          }
        },
        {
          title: "有效期",
          dataIndex: "day",
          customRender:({record})=>{
            return  record.day+'天'
          }
        },
        {
          title: "状态",
          dataIndex: "status",
          customRender:({record})=>{
            return  record.status==0?'禁用':'启用'
          }
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");
      const ruleForm = ref()

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      // 时间筛选
      const onChange = (e) => {
        search.value.start_time = e[0]
        search.value.end_time = e[1]
      }
      const parcelState = (e) => {
        $Modal.confirm({
          title:'包邮卡'+ (e.status ? '禁用':'开启'),
          centered:true,
          content: '确定要'+(e.status ? '禁用':'开启')+'该包邮卡吗？', onOk:async () => {
            let res = await setParcelState({id:e.id}).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            }else {
              message.error(res.msg);
            }
          }
        })
      }
      const openAdd = async(e) =>{
        if(e == 0){
          state.visible = true
          form.value={}
        }else{
          let res = await getParcelMore(e.id).then(res => res.data);
          if (iscode(res)) {
            form.value = res.data
            state.visible = true
          }else {
            message.error(res.msg);
          }
        }
      }
      const handleCancel = () =>{
        form.value = defForm
      }
      const onSubmit = () => {
        ruleForm.value.validate().then(async() => {
          let res
          const hide = message.loading('正在加载中...', 0);
          if (form.value.id) {
            res = await setParcelEdit(form.value).then(res => res.data);
          } else {
            res = await setParcelAdd(form.value).then(res => res.data);
          }
          if (iscode(res)) {
            message.success(res.msg);
            state.visible = false
            setTimeout(hide);
            setTimeout(() => {
              initData(search.value);
            }, 1000);
          }else {
            message.error(res.msg);
            setTimeout(hide);
          }
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getParcelList(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        initData(search.value);
      });
      return {
        ...toRefs(state),
        form,
        ruleForm,
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        onChange,
        parcelState,
        onSubmit,
        openAdd,
        handleCancel
      };
    },
  };
</script>